import { BookingSegmentToTraveler } from '@/types/trip'

import { arrayLast } from './array-utils'

export function getBookingSegmentToTravelerError({ cloned_booking_errors }: BookingSegmentToTraveler) {
	return arrayLast(cloned_booking_errors)
}
